import { useEffect, useState } from 'react';
import { registerSW } from 'virtual:pwa-register';

/**
 * Control de versión de la app instalada.
 *
 * La versión nueva no se aplica sola: espera a que la persona la acepte. Antes
 * la app se actualizaba y recargaba la pantalla en medio del trabajo, y quien
 * estaba escribiendo una guía la perdía.
 *
 * Tampoco se puede callar: una versión vieja mostrando números viejos es
 * exactamente el problema que esta app vino a resolver. Por eso se avisa con
 * una franja que no se va hasta que se actualiza.
 */
export function useActualizacion() {
  const [hayVersionNueva, setHayVersionNueva] = useState(false);
  const [listaSinConexion, setListaSinConexion] = useState(false);
  const [actualizar, setActualizar] = useState<(() => void) | null>(null);

  useEffect(() => {
    // En desarrollo no hay service worker registrado.
    if (!('serviceWorker' in navigator)) return;

    const actualizarSW = registerSW({
      immediate: true,
      onNeedRefresh() {
        setHayVersionNueva(true);
      },
      onOfflineReady() {
        setListaSinConexion(true);
      },
    });

    setActualizar(() => () => void actualizarSW(true));

    /**
     * Busca versiones nuevas cada media hora. Sólo busca: si encuentra una,
     * aparece el aviso y nada más. Antes también miraba al recuperar el foco,
     * y con varias publicaciones seguidas eso interrumpía cada pocos minutos.
     */
    const t = setInterval(
      () => {
        void navigator.serviceWorker.getRegistration().then((r) => r?.update());
      },
      30 * 60 * 1000,
    );

    return () => clearInterval(t);
  }, []);

  return { hayVersionNueva, listaSinConexion, actualizar };
}
